import './modal.scss';

import PropTypes from 'prop-types';
import React from 'react';
import { createPortal } from 'react-dom';

import { ReactComponent as Close } from '../../assets/icons/close.svg';

const Modal = ({ header, children, icon = '', onModalClose, Icon, ariaLabel }) => {
  const portalTarget = document.querySelector('#root') || document.body;

  if (!portalTarget) {
    return null;
  }

  return createPortal(
    <div className="modal" role="dialog" aria-modal="true" aria-label={ariaLabel}>
      <div className="modal__content">
        <button className="modal__close" onClick={onModalClose} data-testid="modal-close">
          <Close />
        </button>
        {(header || Icon) && (
          <div className="modal__header">
            {Icon && <Icon role="img" />}
            {icon}
            <h3>
              {header && header.name}{' '}
              {header && header.cursive && <span className="text-cursive">{header.cursive}</span>}
            </h3>
          </div>
        )}
        <div className="modal__body">{children}</div>
      </div>
    </div>,
    portalTarget
  );
};

Modal.propTypes = {
  children: PropTypes.node,
  header: PropTypes.objectOf(PropTypes.string),
  icon: PropTypes.string,
  onModalClose: PropTypes.func,
  Icon: PropTypes.node,
  ariaLabel: PropTypes.string
};

export { Modal };
